import { useEffect, useState } from 'react';
import { PAYCENTER } from 'consts';
import useFlags from '../../../../../../implementation/Fsp/Detail/common/hooks/useFeatureFlags';

const ValidateInstantPayment = (transactionType) => {
  const {
    data,
    loading: flagLoading,
    error,
  } = useFlags('on-trac-pay-center-hist-trans');
  const [showPayCenterRequestAndTrackingId, setPayCenterRequestAndTrackingId] =
    useState(false);

  useEffect(() => {
    if (!flagLoading && data !== null && data.FlagValue !== null) {
      setPayCenterRequestAndTrackingId(data.FlagValue);
    }
  }, [data, flagLoading, error]);
  return (
    transactionType === PAYCENTER && showPayCenterRequestAndTrackingId === true
  );
};
export default ValidateInstantPayment;
